if (process.env.WHERE == 'standalone') {
  module.exports = process.env.NODE_ENV === 'production' ? require('./config.standalone-prod.js') : require('./config.standalone-dev.js');
} else if (process.env.WHERE == 'champions') {
  module.exports = process.env.NODE_ENV === 'production' ? require('./config.champions-prod.js') : require('./config.champions-dev.js');
}else if (process.env.WHERE == 'nations') {
  module.exports = process.env.NODE_ENV === 'production' ? require('./config.nations-prod.js') : require('./config.nations-dev.js');
}else {
  module.exports = process.env.NODE_ENV === 'production' ? require('./config.seriea-prod.js') : require('./config.seriea-dev.js');
}


// if (process.env.NATIONS === true) {
//   module.exports = process.env.NODE_ENV === 'production' ? require('./config.nations-prod.js') : require('./config.nations-dev.js');
// } else if (process.env.CHAMPIONS === true) {
//   module.exports = process.env.NODE_ENV === 'production' ? require('./config.champions-prod.js') : require('./config.champions-dev.js');
// } else {
//   module.exports = process.env.NODE_ENV === 'production' ? require('./config.fantapazz.js') : require('./config.test.js');
// }
